export default "__VITE_PUBLIC_ASSET__ce2dee10__"